import { isPmnTransferEnabled } from '@/auth/featureToggles';
import { datasetManagePermissions } from '../sharing/constants';
import { datasetTransferTypes } from './constants';
import { datasourceFeatureStatuses } from '../datasource/constants';

export const datasetTransferTypesDiff = (current, next) => {
  const added = next.filter((item) => !current.includes(item)).map((item) => datasetTransferTypes[item]);
  const removed = current.filter((item) => !next.includes(item)).map((item) => datasetTransferTypes[item]);
  return {
    key: added[0] || removed[0],
    value: added.length === 1,
  };
};

const datasetNotificationSettings = ({ settings, permissions }, isGuest = false) => ({
  notificationHistoryAllowed: settings.allow_dataset_update_subscriptions && !isGuest,
  notifyAllowed: settings.allow_dataset_update_subscriptions
    && permissions[datasetManagePermissions.NOTIFY]
    && !isGuest,
});

export const supportedTransferTypes = (datasourceTransferFeatures = {}) => {
  const transferTypes = { ...datasetTransferTypes };
  if (!isPmnTransferEnabled()) { delete transferTypes.PMN; }
  if (datasourceTransferFeatures.clear === datasourceFeatureStatuses.UNSUPPORTED) {
    delete transferTypes.CLEAR;
  }
  if (datasourceTransferFeatures.pseudonymisation === datasourceFeatureStatuses.UNSUPPORTED) {
    delete transferTypes.PMN;
  }
  if (datasourceTransferFeatures.manual === datasourceFeatureStatuses.UNSUPPORTED) {
    delete transferTypes.MANUAL;
  }
  if (datasourceTransferFeatures.token === datasourceFeatureStatuses.UNSUPPORTED) {
    delete transferTypes.TOKEN;
  }

  return transferTypes;
};

export const allowedTransferTypes = (settings) => {
  const transferTypes = supportedTransferTypes();
  if (!settings.allow_clear) { delete transferTypes.CLEAR; }
  if (!settings.allow_pseudonymised) { delete transferTypes.PMN; }
  if (!settings.allow_manual) { delete transferTypes.MANUAL; }
  if (!settings.allow_token) { delete transferTypes.TOKEN; }
  return transferTypes;
};

export const datasetWizardConfirmationIcon = (datasourceChanged, templateChanged) => {
  if (datasourceChanged && templateChanged) {
    return { icon: 'cogs', title: 'dataset.settings.change.title', message: 'dataset.confirm.settings.change' };
  }
  if (datasourceChanged) {
    return { icon: 'server', title: 'settings.datasource.change.title', message: 'settings.confirm.datasource.change' };
  }
  return { icon: 'book', title: 'settings.catalogue.change.title', message: 'settings.confirm.catalogue.change' };
};

export default datasetNotificationSettings;
